import { t } from "i18next";
import { AppInputSwitcher } from "../AppInputSwitcher/AppInputSwitcher";
import React, { useEffect, useRef, useState } from "react";
import { useWebCheckInForm } from "../../../hooks/WebCheckInForm_2";
import { useTranslation } from "react-i18next";
import { PrivateUserForm } from "../../../views/pay/PrivateUserForm";
import {
  DefaultValuesDetailsForm,
  DetailsFormValues,
  IndividualFormProps,
} from "../WebCheckInForms/WebCheckInForms.props";
import {
  CompanyInvoiceFormFields,
  ReadOnlyIfInitialValuesNotProvided,
} from "../WebCheckInForms/FormOptions";
import { AppRadioButton } from "../../UI/AppRadioButtons/AppRadioButtons";
import { Controller, RegisterOptions } from "react-hook-form";
import { FormFieldErrorMessage } from "../../UI/FormFieldErrorMessage/FormFieldErrorMessage";
import AppButton from "../../UI/AppButtons";
import { BookingApi } from "../../../API/Apis/BookingApi";
import { useLocation, useNavigate } from "react-router-dom";
import { companiesForm } from "../../../hooks/CompaniesForm";
import BookingGetters from "../../../store/onlineBooking/getters";
import CollapsibleNavbar from "../ReservedAreaDashboard/CollapseNavbar";
import Recep from "../../../views/chooseVehicle/Recep";

function AnagraphicData({
  values = {},
  initialValues = { ...DefaultValuesDetailsForm },
  onChange = () => {},
  updateActiveSteps,
  dealerId,
}: IndividualFormProps) {
  const { t: translate } = useTranslation();
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const navigateTo = useNavigate();
  const [userDetails, setUserDetails] = useState<DetailsFormValues>({
    ...DefaultValuesDetailsForm,
  });
  const isSmallScreen = window.innerWidth <= 768;
  const [userType, setUserType] = useState("Private");
  const [userEntityType, setUserEntityType] = useState("");
  const isDesktopScreen = window.innerWidth >= 1310;
  const bookingInformation = BookingGetters.getBookingDetails();
  const idSupplier = bookingInformation?.pickUpLocationDetails?.dealerId
    ? bookingInformation.pickUpLocationDetails.dealerId
    : dealerId;
  const handleUserType = (userType) => {
    setUserType(userType);
  };
  useEffect(() => {
    if (userType == "Individual") {
      setUserEntityType("soletrader");
    } else if (userType == "Company") {
      setUserEntityType("legalentity");
    } else {
      setUserEntityType("");
    }
  }, [userType]);
  const [formStates, formFields] = useWebCheckInForm(
    PrivateUserForm,
    userDetails,
    (e) => {
      setUserDetails({ ...userDetails, ...e });
    }
  );
  const handleCountryChange = () => {
    formStates.setValue("city", "");
    formStates.setValue("state", "");
  };
  const [companyinvoiceDetails, setCompanyinvoiceDetails] = useState<any>([]);
  const [
    {
      setValue,
      getValues,

      register,
      formState: { errors },
      control,
      handleSubmit: rhfHandleSubmit,
    },
    individualFormFields,
  ] = companiesForm(
    CompanyInvoiceFormFields,
    {
      ...Object.keys(values).reduce((prevValue, currentKey) => {
        prevValue[currentKey] =
          prevValue[currentKey] || initialValues[currentKey];
        return prevValue;
      }, values),
    },
    onChange
  );
  useEffect(() => {
    document.body.style.overflowX = "hidden";

    return () => {
      document.body.style.overflowX = "";
    };
  }, []);
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: 520 + anagraphicPageDivHeight + 120, //520 is recep height and 120 is for scroll
        },
      },
      targetOrigin
    );
  }
  const showNewIFrame = (iframeFor) => {
    window.parent.postMessage(
      {
        event_id: iframeFor,
      },
      targetOrigin
    );
  };
  useEffect(() => {
    requestParentResize();
  }, []);
  const paymentDetailsSelected =
    BookingGetters.getSelectedVehicleDetails()?.paymentDetails;
  const extrasSelected = paymentDetailsSelected?.addedExtraOptions;
  const [isDriverOptionalSelected, setIsDriverSelected] = useState(false);
  // const [additionalDriverCount, setAdditionalDriverCount] = useState(0);
  useEffect(() => {
    // if (Array.isArray(extrasSelected)) {
    //   // const driverExtras = extrasSelected.filter((el) => el.name === "DRIVER");
    //   // if (driverExtras != null && driverExtras.length > 0) {
    //   //   setAdditionalDriverCount(
    //   //     driverExtras[0].quantity > 2 ? 2 : driverExtras[0].quantity
    //   //   );
    //   // }
    // } else
    if (
      typeof extrasSelected === "object" &&
      extrasSelected !== null &&
      "DRIVER" in extrasSelected
    ) {
      // setAdditionalDriverCount(
      //   extrasSelected.DRIVER.quantity > 2 ? 2 : extrasSelected.DRIVER.quantity
      // );
      setIsDriverSelected(true);
    } else {
      setIsDriverSelected(false);
    }
  }, [extrasSelected]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [isCallFromBooking] = useState(
    (searchParams.has("isCallFromBooking") &&
      searchParams.get("isCallFromBooking") === "true") ||
      (searchParams.has("callFrom") &&
        searchParams.get("callFrom") === "booking")
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };

  const handleCustomerCreation = async () => {
    try {
      setIsSaving(true);
      const response = await BookingApi.createOnlineuserCustomer(
        companyinvoiceDetails,
        "company",
        idSupplier || "",
        userEntityType
      );

      if (response.status !== "success") {
        handleErrorResponse(response.errorMessage);
        return;
      }

      saveUserData(response.id);
      handleNavigation();
    } catch (error) {
      alert("Something went wrong, please try again.");
      updateActiveSteps(2);
    } finally {
      setIsSaving(false);
    }
  };

  const saveUserData = (customerId: string) => {
    localStorage.setItem("attachedCustomer", customerId);
    localStorage.setItem("userEntityType", userEntityType);
    localStorage.removeItem("isPhysicalPerson");
    localStorage.setItem(
      "isPhysicalPerson",
      userEntityType === "legalentity" ? "false" : "true"
    );
  };

  const handleNavigation = () => {
    const isUserLoggedIn = localStorage.getItem("isUserLoggedin");

    if (isUserLoggedIn) {
      if (userEntityType === "legalentity") {
        navigateTo(
          `/driverForm?isCompanyUserType=true&isDriverFromAnagraph=true&isCallFromBooking=${isCallFromBooking}&isDriver=true&showRecep=true`
        );
        return;
      }
      if (idSupplier) {
        if (!isDriverOptionalSelected) {
          isCallFromBooking
            ? navigateTo("/paymentData?fromSignIn=true")
            : updateActiveSteps(3);
        } else {
          navigateTo(
            `/driverForm?isCallFromBooking=${isCallFromBooking}&isDriver=true&showRecep=true`
          );
        }
        return;
      }
    }
    navigateTo("/");
  };

  const handleErrorResponse = (errorMessage: string) => {
    if (
      errorMessage === "More than one Account is registered with this email" ||
      errorMessage === "Account Not Registered with this Email ID"
    ) {
      alert(`${errorMessage}. Please contact the administrator.`);
      navigateTo("/");
    } else {
      updateActiveSteps(2);
      alert("Something went wrong, please try again.");
    }
  };
  //For recep
  const divRef = useRef<HTMLDivElement | null>(null);
  const [offsetFromTop, setOffsetFromTop] = useState(0);
  useEffect(() => {
    const calculateOffset = () => {
      if (divRef.current) {
        const rect = divRef.current.getBoundingClientRect();
        setOffsetFromTop(rect.top); // Directly use rect.top, which updates as you scroll
      }
    };
    calculateOffset(); // Calculate once when activeStep changes
    // Add scroll event listener to update the offset during scroll
    const handleScroll = () => {
      calculateOffset();
    };
    window.addEventListener("scroll", handleScroll); // Listen to scroll events
    // Cleanup the event listener on unmount or when activeStep changes
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  const selectedFields = BookingGetters.getselectedFields();
  const reduxPrices = BookingGetters.getReduxPrices();
  const { vehiclePrice, insurancePrice, onlyExtrasPrice, totalPrice } =
    reduxPrices.setPrices || {};
  const selectedFieldValues = selectedFields?.selectedFields?.selectedFields;
  const selectedVehicleDetails = BookingGetters.getSelectedVehicleDetails();
  const vehicleDetails = selectedVehicleDetails.vehicleDetails;
  const shouldRenderRecep =
    isCallFromBooking &&
    vehicleDetails &&
    selectedFieldValues &&
    vehiclePrice != null &&
    insurancePrice != null &&
    onlyExtrasPrice != null &&
    totalPrice != null;
  const onPrivateFormSubmit = async () => {
    setIsSaving(true);
    BookingApi.createOnlineuserCustomer(
      userDetails,
      "enduser",
      idSupplier || "",
      userEntityType
    ).then((e) => {
      if (e.status == "success") {
        localStorage.setItem("attachedCustomer", e.id);
        const isUserLoggedIn = localStorage.getItem("isUserLoggedin");
        localStorage.setItem("isPhysicalPerson", "true");
        if (idSupplier && isUserLoggedIn) {
          if (!isDriverOptionalSelected) {
            if (isCallFromBooking) {
              navigateTo("/paymentData?fromSignIn=true");
            } else {
              updateActiveSteps(3);
            }
          } else {
            navigateTo(
              `/driverForm?isCallFromBooking=${isCallFromBooking}&isDriver=true&showRecep=true`
            );
          }
        } else {
          navigateTo("/", {
            state: { from: window.location.href },
          });
          showNewIFrame("showIFrameForBooking");
        }
      } else if (
        e.errorMessage ===
          "More than one Account is registered with this email" ||
        e.errorMessage === "Account Not Registered with this Email ID"
      ) {
        alert(`${e.errorMessage}. Please contact the administrator.`);
        navigateTo("/");
      } else {
        updateActiveSteps(2);
        alert("something went wrong please try again.");
      }
    });
  };

  //form form private user
  const renderFormField = (el, index) => {
    const label = translate(el.label || "");
    const placeholder = translate(el.placeholder || "");
    const options =
      el.key === "sex" ? [translate("MALE"), translate("FEMALE")] : el.options;
    const value = userDetails[el.key] || formStates.getValues(el.key);

    const containerWidth =
      isDesktopScreen && el.key !== "streetName" && el.key !== "streetNumber"
        ? "418px"
        : isDesktopScreen && el.key === "streetNumber"
        ? "142px"
        : isDesktopScreen && el.key === "streetName"
        ? "265px"
        : "330px";

    const className = `box-border ${
      el.key === "dummyNode" ? "invisible" : ""
    } ${el.key === "streetNumber" && !isSmallScreen ? "ml-[-51%]" : ""} ${
      el.key === "sex" && !isDesktopScreen ? "mb-[9%]" : ""
    } ${el.key === "ssnNumber" ? "mt-[-16%]" : ""}`;

    if (["date"].includes(el.type)) {
      return (
        <Controller
          key={el.key || index}
          control={control}
          name={el.key}
          rules={{ required: "This field is required" }}
          render={({ field, fieldState }) => (
            <AppInputSwitcher
              {...el}
              {...field}
              value={value}
              onchange={(e) => {
                field.onChange(e);
                formStates.setValue(el.key, e.toString(), {
                  shouldValidate: true,
                });
              }}
              error={fieldState.error?.message}
              containerwidth={!isSmallScreen ? "418px" : "330px"}
              containerheight="38px"
              InputColor={true}
              label={label}
              placeholder={placeholder}
              minDate={el.minDate}
              showlabelOnShrink={false}
              className="box-border"
              showlabel={true}
              fontFamilyForLabel="MBCorpoSText-CondRegular-Web"
              fontFamilyForInput="MBCorpoSText-CondRegular-Web"
            />
          )}
        />
      );
    }

    return (
      <AppInputSwitcher
        {...el}
        key={index}
        containerwidth={containerWidth}
        containerheight="38px"
        label={label}
        placeholder={placeholder}
        showlabel={true}
        showlabelOnShrink={false}
        className={className}
        value={value}
        InputColor={true}
        options={options}
        onchange={(e) => {
          if (el.key === "country") {
            handleCountryChange();
          }
          formStates.setValue(el.key, e.toString(), {});
        }}
        fontFamilyForLabel="MBCorpoSText-CondRegular-Web"
        fontFamilyForInput="MBCorpoSText-CondRegular-Web"
        onInvalid={(e) => {
          const fieldKey = userDetails[el.key] || formStates.getValues(el.key);
          if (e.target.validity.valueMissing && !fieldKey) {
            e.target.setCustomValidity(translate("Please fill out this field"));
          } else {
            e.target.setCustomValidity("");
          }
        }}
      />
    );
  };
  const [anagraphicPageDivHeight, SetAnagraphicPageDivHeight] =
    useState<number>(0);
  const anagraphicDataRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (anagraphicDataRef.current) {
      const anagraphicPageHeight = anagraphicDataRef.current.offsetHeight;
      SetAnagraphicPageDivHeight(anagraphicPageHeight);
    }
  });
  useEffect(() => {
    requestParentResize();
  }, [anagraphicPageDivHeight]);

  return (
    <>
      {shouldRenderRecep && (
        <div>
          <Recep
            offsetFromTop={offsetFromTop}
            divRef={divRef}
            activeStep="3"
            selectedVehicle={vehicleDetails}
            selectedFields={selectedFieldValues}
            vehiclePrice={vehiclePrice}
            insurancePrice={insurancePrice}
            onlyExtrasPrice={onlyExtrasPrice}
            totalPrice={totalPrice}
            isPaymentPage={false}
            fromAnagraphDriver={true}
          />
        </div>
      )}
      <div
        style={{
          width: isDesktopScreen ? "1259px" : isSmallScreen ? "" : "850px",
          margin: "auto",
          marginLeft: !isSmallScreen ? "auto" : "",
          boxShadow: "0 2px 2px #B3B3B3, 0 2px 2px #B3B3B3",
        }}
        ref={anagraphicDataRef}
      >
        <div style={{ width: "2%" }}>
          <CollapsibleNavbar
            isDrawerOpen={isDrawerOpen}
            toggleDrawer={toggleDrawer}
          />
        </div>
        <div
          className={"flex flex-col md:flex-row items-center"}
          style={{
            padding: isSmallScreen ? "20px" : "12px",
          }}
        >
          <img
            src="/assets/images/SiteLogo.jpg"
            alt={"logo"}
            style={{
              height: "134px",
              width: "231.03px",
              marginTop: "47px",
              marginRight: !isSmallScreen ? "" : "85%",
            }}
          />
          <div>
            <h2
              className="text-black"
              style={{
                fontSize: isSmallScreen ? "32px" : "36px",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
              }}
            >
              {t("Complete your account")}
            </h2>
            <h3
              className="text-black"
              style={{
                fontSize: isSmallScreen ? "20px" : "24px",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
              }}
            >
              {t("Insert your anagraphic data")}
            </h3>
          </div>
        </div>
        <div
          className={` ${
            isSmallScreen ? "box-border justify-center flex px-4" : ""
          }`}
          style={{
            backgroundColor: "#000000",
          }}
        >
          <div
            style={{
              marginLeft: isDesktopScreen
                ? "148px"
                : isSmallScreen
                ? ""
                : "10px",
              marginTop: "60px",
              width: isDesktopScreen ? "1075px" : isSmallScreen ? "" : "850px",
              marginBottom: isSmallScreen ? "" : "90px",
            }}
          >
            <h3
              className={`${isSmallScreen ? "box-border flex px-4" : ""}`}
              style={{
                color: "#ffffff",
                fontSize: "15px",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                padding: "12px",
                paddingLeft: isDesktopScreen ? "0px" : "12px",
              }}
            >
              {t("Select User Type")}
            </h3>
            <AppRadioButton
              className={`${
                isSmallScreen ? "box-border justify-center flex px-4" : ""
              }`}
              required={true}
              value={userType}
              color={"white"}
              onChange={(e) => {
                handleUserType(e);
              }}
              fontFamilyForLabel="MBCorpoSText-CondRegular-Web"
              fontFamilyForInput="MBCorpoSText-CondRegular-Web"
              options={[
                {
                  label: t("Private"),
                  value: "Private",
                },
                {
                  label: t("Individual"),
                  value: "Individual",
                },
                {
                  label: t("Company"),
                  value: "Company",
                },
              ]}
            />
            {userType === "Private" ? (
              <div
                className={`box-border justify-center ${
                  isSmallScreen ? "flex px-4" : ""
                }`}
              >
                <form
                  className={`grid sm:grid-cols-2 md:grid-cols-2 gap-4 ${
                    isSmallScreen ? "w-full max-w-[600px]" : ""
                  }`}
                  onSubmit={rhfHandleSubmit(onPrivateFormSubmit)}
                >
                  {Object.values(formFields).map((el, index) => {
                    // const isControllerField = ["date"].includes(el.type);
                    return (
                      <div className="w-full h-full" key={el.key || index}>
                        {/* {isControllerField ? (
                          <Controller
                            control={control}
                            name={el.key}
                            rules={{ required: "This field is required" }}
                            render={({ field, fieldState }) => (
                              <AppInputSwitcher
                                {...el}
                                {...field}
                                value={
                                  userDetails[el.key] ||
                                  formStates.getValues(el.key)
                                }
                                onchange={(e) => {
                                  field.onChange(e);
                                  formStates.setValue(el.key, e.toString(), {
                                    shouldValidate: true,
                                  });
                                }}
                                error={fieldState.error?.message}
                                containerwidth={
                                  !isSmallScreen ? "418px" : "330px"
                                }
                                containerheight="38px"
                                InputColor={true}
                                label={translate(el.label || "")}
                                placeholder={translate(el.placeholder || "")}
                                minDate={el.minDate}
                                showlabelOnShrink={false}
                                className="box-border"
                                showlabel={true}
                              />
                            )}
                          />
                        ) : (
                          <AppInputSwitcher
                            {...el}
                            key={index}
                            containerwidth={
                              isDesktopScreen &&
                              el.key != "streetName" &&
                              el.key != "streetNumber"
                                ? "418px"
                                : isDesktopScreen && el.key == "streetNumber"
                                ? "142px"
                                : isDesktopScreen && el.key == "streetName"
                                ? "265px"
                                : "330px"
                            }
                            containerheight="38px"
                            label={translate(el.label || "")}
                            placeholder={translate(el.placeholder || "")}
                            showlabel={true}
                            showlabelOnShrink={false}
                            className={`box-border ${
                              el.key === "dummyNode" ? "invisible" : ""
                            } ${
                              el.key === "streetNumber"
                                ? isSmallScreen
                                  ? ""
                                  : "ml-[-51%]"
                                : ""
                            } ${
                              el.key === "sex" && !isDesktopScreen
                                ? "mb-[9%]"
                                : ""
                            } 
                            ${el.key === "ssnNumber" ? "mt-[-13%]" : ""}`}
                            value={
                              userDetails[el.key] ||
                              formStates.getValues(el.key)
                            }
                            InputColor={true}
                            options={
                              el.key === "sex"
                                ? [translate("MALE"), translate("FEMALE")]
                                : el.options
                            }
                            onchange={(e) => {
                              if (el.key === "country") {
                                handleCountryChange();
                              }
                              formStates.setValue(el.key, e.toString(), {});
                            }}
                            onInvalid={(e) => {
                              const fieldKey =
                                userDetails[el.key] ||
                                formStates.getValues(el.key);
                              if (e.target.validity.valueMissing && !fieldKey) {
                                e.target.setCustomValidity(
                                  translate("Please fill out this field")
                                );
                              } else {
                                e.target.setCustomValidity("");
                              }
                            }}
                          />
                        )} */}
                        {renderFormField(el, index)}
                        <FormFieldErrorMessage>
                          {errors[el.key]?.message}
                        </FormFieldErrorMessage>
                      </div>
                    );
                  })}
                  <div
                    className=""
                    style={{
                      marginBottom: "40px",
                      marginTop: isSmallScreen ? "" : "-20px",
                      marginLeft: isSmallScreen ? "" : "103%",
                    }}
                  >
                    <AppButton
                      loading={isSaving}
                      type="submit"
                      color="primary"
                      className={`h-[38px] flex justify-center rounded-sm ${
                        isDesktopScreen ? "w-[410px]" : "w-[330px]"
                      }`}
                    >
                      <span
                        className="flex text-center w-full h-full mt-3 justify-center"
                        style={{
                          marginBottom: "12px",
                          textTransform: "none",
                          fontFamily: "MBCorpoSText-Regular-Web-new",
                        }}
                      >
                        {t("Confirm")}
                      </span>
                    </AppButton>
                  </div>
                </form>
              </div>
            ) : (
              <div
                className={`box-border justify-center ${
                  isSmallScreen ? "flex px-4" : ""
                }`}
                // className="grid sm:grid-cols-2 md:grid-cols-2 gap-4"
              >
                <form
                  className={`grid sm:grid-cols-2 md:grid-cols-2 gap-4 ${
                    isSmallScreen ? "w-full max-w-[600px]" : ""
                  }`}
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleCustomerCreation();
                  }}
                >
                  {Object.values(individualFormFields).map((el, index) => {
                    let readOnly;
                    el.readOnly ||
                      (ReadOnlyIfInitialValuesNotProvided.includes(el.key) &&
                        !!initialValues[el.key]);
                    const options: RegisterOptions = {
                      required: {
                        value: !!el.required && !readOnly,
                        message: translate("Please fill out this field"),
                      },
                    };
                    if (el.type === "email") {
                      options.pattern = {
                        value: /^[a-zA-Z\d+_.-]+@[a-zA-Z\d.-]+$/,
                        message: "Please provide a valid email",
                      };
                    }
                    const isControllerField = ["date"].includes(el.type);
                    return (
                      <>
                        {userType === "Company" &&
                        (el.key === "birthNation" ||
                          el.key === "birthPlace" ||
                          el.key === "dateOfBirth" ||
                          el.key === "birthProvince" ||
                          el.key === "taxCode" ||
                          el.key === "firstName" ||
                          el.key === "lastName" ||
                          el.key === "sex") ? (
                          ""
                        ) : (
                          <div key={index}>
                            {isControllerField ? (
                              <Controller
                                control={control}
                                name={el.key}
                                rules={{
                                  required: "This field is required",
                                }}
                                render={({ field, fieldState }) => (
                                  <AppInputSwitcher
                                    {...el}
                                    {...field}
                                    value={
                                      getValues(el.key) ||
                                      initialValues[el.key] ||
                                      values[el.key] ||
                                      ""
                                    }
                                    onchange={(e) => {
                                      const r: any = Object.keys(
                                        CompanyInvoiceFormFields
                                      ).at(index);
                                      setCompanyinvoiceDetails({
                                        ...companyinvoiceDetails,
                                        [r]: e,
                                      });
                                      setValue(el.key, e || "", {
                                        shouldValidate: true,
                                      });
                                      formStates.setValue(
                                        el.key,
                                        e.toString(),
                                        {}
                                      );
                                    }}
                                    error={fieldState.error?.message}
                                    containerwidth={
                                      !isSmallScreen ? "418px" : "330px"
                                    }
                                    containerheight="38px"
                                    InputColor={true}
                                    label={translate(el.label || "")}
                                    placeholder={translate(
                                      el.placeholder || ""
                                    )}
                                    readOnly={readOnly}
                                    minDate={el.minDate}
                                    showlabelOnShrink={false}
                                    className={`box-border`}
                                    showlabel={true}
                                    fontFamilyForLabel="MBCorpoSText-CondRegular-Web"
                                    fontFamilyForInput="MBCorpoSText-CondRegular-Web"
                                  />
                                )}
                              />
                            ) : (
                              <AppInputSwitcher
                                {...el}
                                key={index}
                                autocomplete={false}
                                {...register(el.key, {
                                  ...options,
                                })}
                                showlabel={true}
                                containerwidth={
                                  isDesktopScreen
                                    ? userType === "company"
                                      ? el.key === "streetNumber"
                                        ? "142px"
                                        : el.key === "streetName"
                                        ? "265px"
                                        : "418px"
                                      : "418px"
                                    : "330px"
                                }
                                containerheight="38px"
                                readOnly={readOnly}
                                value={
                                  getValues(el.key) ||
                                  initialValues[el.key] ||
                                  values[el.key] ||
                                  ""
                                }
                                InputColor={true}
                                options={
                                  el.key === "sex"
                                    ? [translate("MALE"), translate("FEMALE")]
                                    : el.options
                                }
                                label={translate(el.label || "")}
                                placeholder={translate(el.placeholder || "")}
                                className={`box-border ${
                                  el.key === "CompanySSNNumber" ? "" : "ml-0"
                                }`}
                                fontFamilyForLabel="MBCorpoSText-CondRegular-Web"
                                fontFamilyForInput="MBCorpoSText-CondRegular-Web"
                                onchange={(e) => {
                                  const r: any = Object.keys(
                                    CompanyInvoiceFormFields
                                  ).at(index);
                                  setCompanyinvoiceDetails({
                                    ...companyinvoiceDetails,
                                    [r]: e,
                                  });

                                  setValue(el.key, e || "", {
                                    shouldValidate: true,
                                  });

                                  if (el.key === "country") {
                                    handleCountryChange();
                                  }
                                  formStates.setValue(el.key, e.toString(), {});
                                }}
                                onInvalid={(e) => {
                                  const fieldKey =
                                    userDetails[el.key] ||
                                    formStates.getValues(el.key);
                                  if (
                                    e.target.validity.valueMissing &&
                                    !fieldKey
                                  ) {
                                    e.target.setCustomValidity(
                                      translate("Please fill out this field")
                                    );
                                  } else {
                                    e.target.setCustomValidity("");
                                  }
                                }}
                              />
                            )}
                            <FormFieldErrorMessage>
                              {errors[el.key]?.message}
                            </FormFieldErrorMessage>
                          </div>
                        )}
                      </>
                    );
                  })}
                  {/*</div>*/}
                  <div
                    className="flex flex-row"
                    style={{
                      marginBottom: "40px",
                      marginTop: "40px",
                      // marginLeft: isSmallScreen ? "" : "",
                    }}
                  >
                    <AppButton
                      loading={isSaving}
                      type="submit"
                      color="primary"
                      className={`h-[38px] flex justify-center rounded-sm ${
                        isDesktopScreen ? "w-[410px]" : "w-[330px]"
                      }`}
                    >
                      <span
                        className="flex text-center w-full h-full mt-3 justify-center"
                        style={{
                          marginTop: "0px",
                          textTransform: "none",
                          fontFamily: "MBCorpoSText-Regular-Web-new",
                        }}
                      >
                        {t("Confirm")}
                      </span>
                    </AppButton>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export { AnagraphicData };
